export * from './Tag.theme';

export { Tag, TagLeftIcon, TagLabel, TagRightIcon } from '@chakra-ui/react';
export type { TagProps } from '@chakra-ui/react';
